import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { apiRoutesUrls } from "../../Api/ApiNames";
import { typeOfImageToLink } from '../../Components/Helpers/selectType';
import translation from "../../Components/Helpers/translation";
import styles from './AdvertisementRectangle.module.scss';

function AdvertisementSquare() {
	const [combinedData, setCombinedData] = useState([]);
	const history = useHistory();
	const { lang } = useParams();
	const sliderRef = useRef(null);
	const resizeObserver = useRef(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const res1 = await fetch(`${apiRoutesUrls.main}${apiRoutesUrls.mainPage}44?limit=5&offset=0&lang=${lang}`);
				const json1 = await res1.json();

				const res2 = await fetch(`${apiRoutesUrls.main}${apiRoutesUrls.mainPage}47?limit=4&offset=0&lang=${lang}`);
				const json2 = await res2.json();

				setCombinedData([...json1, ...json2]);
			} catch (error) {
				console.error("Błąd podczas pobierania danych:", error);
			}
		};

		fetchData();
	}, [lang]);

	useEffect(() => {
		if (sliderRef.current) {
			let scrollAmount = 0;
			const scrollSpeed = 1;
			const slider = sliderRef.current;

			function autoScroll() {
				if (slider) {
					scrollAmount += scrollSpeed;
					if (scrollAmount >= slider.scrollWidth / 2) {
						scrollAmount = 0;
					}
					slider.scrollLeft = scrollAmount;
				}
				requestAnimationFrame(autoScroll);
			}

			autoScroll();
		}
	}, [combinedData]);

	// useEffect(() => {
	// 	const updateImageSize = () => {
	// 		const images = document.querySelectorAll(`.${styles.sliderItem}`);
	// 		images.forEach(img => {
	// 			const width = img.offsetWidth;
	// 			img.style.height = `${width * 0.75}px`;
	// 		});
	// 	};

	// 	if (sliderRef.current) {
	// 		updateImageSize();
	// 		resizeObserver.current = new ResizeObserver(updateImageSize);
	// 		resizeObserver.current.observe(sliderRef.current);
	// 	}

	// 	return () => {
	// 		if (resizeObserver.current) {
	// 			resizeObserver.current.disconnect();
	// 		}
	// 	};
	// }, [combinedData]);

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.leftMenu}>
					<div aria-label={translation.aria.header.logoDMP} title={translation.aria.header.logoDMP} tabIndex={0}>
						<div className={`${lang === "pl" ? styles.dmpPL : styles.dmpEN}`} />
					</div>
				</div>
				{combinedData.length > 0 && (
					<div className={styles.sliderContainer} ref={sliderRef}>
						<div className={styles.sliderTrack}>
							{[...combinedData, ...combinedData].map((item, index) => (
								<div
									key={index}
									className={styles.sliderItem}
									style={{
										backgroundImage: `url(${typeOfImageToLink(item)})`
									}}
								/>
							))}
						</div>
					</div>
				)}
			</div>
		</>
	);
}

export default AdvertisementSquare;
